import React from "react";

// Section heading framed by two gold rules, echoing the poster's ornaments.
// `as` keeps the heading level correct for the document outline.
const SectionHeading = ({ title, subtitle, as: Tag = "h2", id }) => (
  <div className="rm-heading">
    <Tag className="rm-heading__title" id={id}>
      <span className="rm-heading__rule" aria-hidden="true" />
      <span className="rm-heading__text">{title}</span>
      <span className="rm-heading__rule" aria-hidden="true" />
    </Tag>
    {subtitle && <p className="rm-heading__subtitle">{subtitle}</p>}
  </div>
);

export default SectionHeading;
